import type { ApiConnector } from '@/types/accessor/common/connector'
import { type QueryDisastersRequestParam } from '@/types/accessor/api/disaster/disaster'
import { queryDisasters } from '@/accessors/api/requests/disasterOperationDisastersApiGwFuncs'

export const query: ApiConnector = async (param, indexedDBConnector) => {
  const data = await queryDisasters(param as QueryDisastersRequestParam)
  await indexedDBConnector(data)
  return data
}
